import { render, staticRenderFns } from "./WhitelistsList.vue?vue&type=template&id=45e384c0"
import script from "./WhitelistsList.vue?vue&type=script&lang=js"
export * from "./WhitelistsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports